import {
  Avatar,
  Button,
  Dialog,
  DialogContent,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import { format } from 'date-fns';
import { DICTIONARY } from 'Enum';
import {
  useDictionary,
  useIsDesktop,
  usePrescriptionAndUnHandledOrders,
} from 'Hooks';
import { LeftArrow, PreOrderIcon, PurpleClose } from 'Images';
import { Dictionary } from 'Dictionary';
import { NextPrevButton } from 'Components';
import { useNavigate } from 'react-router-dom';
interface IAlertDialogRequest {
  handleClose: () => void;
  open: boolean;
  openRegularMedicationsDialog: () => void;
}
export const AlertDialogOrders = (props: IAlertDialogRequest) => {
  const { handleClose, open } = props;
  const {
    prescriptionsAndUnHandledOrders: { prescriptions },
  } = usePrescriptionAndUnHandledOrders();
  const isDesktop = useIsDesktop();

  const dictionary = useDictionary(
    Dictionary,
    DICTIONARY.Equipment
  ).existingOrderDialog;

  const generalDictionary = useDictionary(Dictionary, DICTIONARY.General);

  const createDate = prescriptions[0]?.createDate;
  const date = createDate ? format(new Date(createDate), 'dd.MM.yy') : '';
  const navigate = useNavigate();

  const handleOnClick = () => {
    navigate('/medicine/createOrder');
  };

  if (prescriptions?.length === 0) {
    return null;
  }

  return (
    <Dialog
      PaperProps={{
        sx: {
          overflowY: 'visible',
          backgroundColor: 'primary.shade_100',
          width: 'calc(100% - 32px)',
        },
      }}
      maxWidth='md'
      fullWidth
      open={open}
      onClose={handleClose}
      sx={{ mt: '10vh' }}
      aria-labelledby={'existing-order-dialog-title'}
      aria-describedby={'existing-order-dialog-content'}
    >
      <IconButton
        onClick={handleClose}
        sx={{
          position: 'absolute',
          right: isDesktop ? '8px' : '13px',
          top: isDesktop ? '12px' : '13px',
        }}
      >
        <Avatar
          alt={generalDictionary.closeWindow}
          src={PurpleClose}
          sx={{
            width: isDesktop ? '42px' : '34px',
            height: isDesktop ? '42px' : '34px',
          }}
        />
      </IconButton>
      <DialogContent
        sx={{
          padding: isDesktop ? '64px' : '48px 20px',
        }}
        id={'existing-order-dialog-content'}
        tabIndex={0}
      >
        <Stack alignItems='center' mt={'0'}>
          <Avatar
            alt=''
            src={PreOrderIcon}
            sx={
              isDesktop
                ? {
                    width: '160px',
                    height: '120px',
                  }
                : { width: '110px', height: '90px' }
            }
          />
          <Typography
            textAlign='center'
            paragraph
            margin={'30px 0 20px 0'}
            component='h2'
            variant='h3'
            id={'existing-order-dialog-title'}
          >
            {dictionary.title}
          </Typography>

          <Typography
            variant='body3'
            textAlign={isDesktop ? undefined : 'center'}
            p={isDesktop ? undefined : '0 20px'}
          >
            {dictionary.info1} {date}
          </Typography>
          {isDesktop ? (
            <Typography
              mt={1}
              variant='body3'
              textAlign={isDesktop ? undefined : 'center'}
              sx={{ display: 'flex', alignItems: 'center' }}
            >
              {dictionary.medicineLine}

              <Button
                sx={{
                  fontSize: '20px',
                  p: 0,
                  alignItems: 'center',
                  ml: '6px',
                  top: '1px',
                }}
                onClick={handleClose}
                endIcon={
                  <Avatar
                    src={LeftArrow}
                    sx={{ width: '20px', height: '20px' }}
                  />
                }
              >
                {dictionary.medicineLineLabel}
              </Button>
            </Typography>
          ) : (
            <Stack mt={1} alignItems={'center'}>
              <Typography
                mt={1}
                variant='body3'
                textAlign={isDesktop ? undefined : 'center'}
                sx={{ display: 'flex', alignItems: 'center' }}
              >
                {dictionary.medicineLine}
              </Typography>
              <Button
                sx={{
                  fontSize: '20px',
                  p: 0,
                  alignItems: 'center',
                  ml: '6px',
                  top: '1px',
                }}
                onClick={handleClose}
                endIcon={
                  <Avatar
                    src={LeftArrow}
                    sx={{ width: '20px', height: '20px' }}
                  />
                }
              >
                {dictionary.medicineLineLabel}
              </Button>
            </Stack>
          )}

          <Stack
            sx={{
              flexDirection: 'row',
              mt: '50px',
              justifyContent: 'center',
              gap: isDesktop ? 6 : 2,
            }}
          >
            <NextPrevButton
              callback={handleOnClick}
              isBlue
              isNext
              text={dictionary.submit}
              style={
                isDesktop
                  ? undefined
                  : {
                      button: { height: '36px' },
                      text: { fontSize: '16px', fontWeight: '600' },
                    }
              }
            />
          </Stack>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};
